import { render, staticRenderFns } from "./ButtonCamara.vue?vue&type=template&id=c5fd4954&scoped=true&"
import script from "./ButtonCamara.vue?vue&type=script&lang=js&"
export * from "./ButtonCamara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fd4954",
  null
  
)

export default component.exports